import { getFragmentData, graphql } from "../gql";
import { useQuery } from "@apollo/client";
import { OneOnOneAssignmentPdfFragment } from "./OneOnOneAssignmentPdfFragment.ts";

export const GetAllOneOnOneAssignmentPdfsQuery = graphql(`
  query getAllOneOnOneAssignmentPdfs {
    getAllOneOnOneAssignmentPdfs {
      ...OneOnOneAssignmentPdf
    }
  }
`);

export function useAllOneOnOneAssignmentPdfs() {
  const { data, loading, refetch } = useQuery(
    GetAllOneOnOneAssignmentPdfsQuery,
    {
      fetchPolicy: "cache-and-network",
    },
  );

  return {
    pdfs: getFragmentData(
      OneOnOneAssignmentPdfFragment,
      data?.getAllOneOnOneAssignmentPdfs ?? [],
    ),
    loading,
    refetch,
  };
}
